import { render, staticRenderFns } from "./Asset.vue?vue&type=template&id=883a3be2&"
import script from "./Asset.vue?vue&type=script&lang=ts&"
export * from "./Asset.vue?vue&type=script&lang=ts&"
import style0 from "./Asset.vue?vue&type=style&index=0&id=883a3be2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports